<template>
  <footer>
    <div class="foot ">

      <div class="zz_blocks" style="max-width: 100%; margin-top: 20px; ">

        <div class="widewidth">
          <h2 class="noborder" style="padding-bottom: 5px;">Kontinuität und Stabilität <br> durch Wandel</h2>

        </div>
        <br>
        <router-link to="/kontakt" class="btn">
          <svg width="24" height="13" viewBox="0 0 24 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 0.5L22.5 6.5M22.5 6.5L16.5 12.5M22.5 6.5H0" stroke="#AD6766"/>
          </svg>
          <div style="padding-left: 5px;">Kontakt aufnehmen</div>
        </router-link>
        <div class="widewidth  bottomline">

          </div>

        </div>

<!--    <div class="widewidth bottomline ">-->
<!--      <div class="d-flex justify-content-around align-items-center">-->

<!--        <router-link to="/datenschutz">Datenschutzerklärung</router-link>-->
<!--      </div>-->
<!--    </div>-->
      </div>

    </div>
  </footer>
</template>
<script>
import store from '@/store'

export default {
  store,
  name: 'Footer.vue',
  data() {
    return {}
  },
  created: function () {
  },
  methods: {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>

a {
  color: #aaa!important;

  &:hover {
    font-weight: 600;
    color: $zzcolor;
  }
}

footer {
border-top: 1px solid $zzcolor;
  width: 100%;
  background-color: transparent;
background-color: #333;
  position: relative;
  padding-bottom: 80px
}

h2 {
  margin-bottom: 0;
}

.foot {
  position: relative;
  margin: 0 auto;
  width: 1280px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 100%;
  justify-content: center;
  display: flex;
  min-height: 200px;
  color: #fff;
  padding-bottom: 10px;
  h2 {
    color: #fff;
    text-align: center;
    border: none;
    font-weight: 400;
  }

  .bottomline {
    //border-top: 1px solid rgba(#fff, 0.8);
    //margin-top: 50px;
    @include mobile {
      margin-bottom: 0;
    }
    margin-bottom: 0;

    & > div {
      padding:10px 0 10px;
      @include mobile {
        padding-top: 20px;
      }

      div {
        padding: 0 40px;
        color: #888;
        text-align: center;
        font-size: 18px;
        line-height: 22px;
        border-right: 1px transparent solid;

        &:last-child {
          padding-right: 0;
          border: none;
        }

        @include mobile {
          border: none;
          padding-right: 0;
        }
      }
    }
  }

  .inner {
    max-width: 100%;
    width: 1280px;
  }

  .btn {
    margin-bottom: 50px;

    font-size: 18px;
    line-height: 120%;
    /* or 14px */
    border: 1px solid #AD6766;
    box-sizing: border-box;
    border-radius: 100px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 5px 10px;
    /* ZZ - Rostrot - heller */
    color: #AD6766;
    background-color: transparent;

    &:focus, &:hover {
      background-color: #ad6766;
      color: #fff;

      svg path {
        stroke: #fff;
      }
    }

  }
}
</style>
